export const zipcodes = [
  // CAPITAL FEDERAL
  '1000',
  '1001',
  '1002',
  '1003',
  '1004',
  '1005',
  '1006',
  '1007',
  '1008',
  '1009',
  '1010',
  '1011',
  '1012',
  '1013',
  '1014',
  '1015',
  '1016',
  '1017',
  '1018',
  '1019',
  '1020',
  '1021',
  '1022',
  '1023',
  '1024',
  '1025',
  '1026',
  '1027',
  '1028',
  '1029',
  '1030',
  '1031',
  '1032',
  '1033',
  '1034',
  '1035',
  '1036',
  '1037',
  '1038',
  '1039',
  '1040',
  '1041',
  '1042',
  '1043',
  '1044',
  '1045',
  '1046',
  '1047',
  '1048',
  '1049',
  '1050',
  '1051',
  '1052',
  '1053',
  '1054',
  '1055',
  '1056',
  '1057',
  '1058',
  '1059',
  '1060',
  '1061',
  '1062',
  '1063',
  '1064',
  '1065',
  '1066',
  '1067',
  '1068',
  '1069',
  '1070',
  '1071',
  '1072',
  '1073',
  '1074',
  '1075',
  '1076',
  '1077',
  '1078',
  '1079',
  '1080',
  '1081',
  '1082',
  '1083',
  '1084',
  '1085',
  '1086',
  '1087',
  '1088',
  '1089',
  '1090',
  '1091',
  '1092',
  '1093',
  '1094',
  '1095',
  '1096',
  '1097',
  '1098',
  '1099',
  '1100',
  '1101',
  '1102',
  '1103',
  '1104',
  '1106',
  '1107',
  '1110',
  '1111',
  '1112',
  '1113',
  '1114',
  '1115',
  '1116',
  '1117',
  '1118',
  '1119',
  '1120',
  '1121',
  '1122',
  '1123',
  '1124',
  '1125',
  '1126',
  '1127',
  '1128',
  '1129',
  '1130',
  '1133',
  '1134',
  '1135',
  '1136',
  '1137',
  '1138',
  '1139',
  '1140',
  '1141',
  '1143',
  '1147',
  '1148',
  '1150',
  '1151',
  '1152',
  '1153',
  '1154',
  '1155',
  '1156',
  '1157',
  '1158',
  '1159',
  '1160',
  '1161',
  '1162',
  '1163',
  '1164',
  '1165',
  '1166',
  '1167',
  '1168',
  '1169',
  '1170',
  '1171',
  '1172',
  '1173',
  '1174',
  '1175',
  '1176',
  '1177',
  '1178',
  '1179',
  '1180',
  '1181',
  '1182',
  '1183',
  '1184',
  '1185',
  '1186',
  '1187',
  '1188',
  '1189',
  '1190',
  '1191',
  '1192',
  '1193',
  '1194',
  '1195',
  '1196',
  '1197',
  '1198',
  '1199',
  '1200',
  '1201',
  '1202',
  '1203',
  '1204',
  '1205',
  '1206',
  '1207',
  '1208',
  '1209',
  '1210',
  '1211',
  '1212',
  '1213',
  '1214',
  '1215',
  '1216',
  '1217',
  '1218',
  '1219',
  '1220',
  '1221',
  '1222',
  '1223',
  '1224',
  '1225',
  '1226',
  '1227',
  '1228',
  '1229',
  '1230',
  '1231',
  '1232',
  '1233',
  '1234',
  '1235',
  '1236',
  '1237',
  '1238',
  '1239',
  '1240',
  '1241',
  '1242',
  '1243',
  '1244',
  '1245',
  '1246',
  '1247',
  '1248',
  '1249',
  '1250',
  '1251',
  '1252',
  '1253',
  '1254',
  '1255',
  '1256',
  '1257',
  '1258',
  '1259',
  '1260',
  '1261',
  '1262',
  '1263',
  '1264',
  '1265',
  '1266',
  '1267',
  '1268',
  '1269',
  '1270',
  '1271',
  '1272',
  '1273',
  '1274',
  '1275',
  '1276',
  '1277',
  '1278',
  '1279',
  '1280',
  '1281',
  '1282',
  '1283',
  '1284',
  '1285',
  '1286',
  '1287',
  '1288',
  '1289',
  '1290',
  '1291',
  '1292',
  '1293',
  '1294',
  '1295',
  '1296',
  '1301',
  '1302',
  '1303',
  '1304',
  '1305',
  '1306',
  '1307',
  '1308',
  '1309',
  '1310',
  '1311',
  '1312',
  '1313',
  '1314',
  '1315',
  '1316',
  '1317',
  '1318',
  '1319',
  '1320',
  '1321',
  '1322',
  '1323',
  '1324',
  '1325',
  '1326',
  '1327',
  '1328',
  '1329',
  '1330',
  '1331',
  '1332',
  '1333',
  '1334',
  '1335',
  '1336',
  '1337',
  '1338',
  '1339',
  '1340',
  '1341',
  '1342',
  '1343',
  '1344',
  '1345',
  '1346',
  '1347',
  '1348',
  '1349',
  '1350',
  '1351',
  '1352',
  '1353',
  '1354',
  '1355',
  '1356',
  '1357',
  '1358',
  '1359',
  '1360',
  '1361',
  '1362',
  '1363',
  '1364',
  '1365',
  '1366',
  '1367',
  '1368',
  '1369',
  '1370',
  '1371',
  '1372',
  '1373',
  '1374',
  '1375',
  '1376',
  '1377',
  '1378',
  '1379',
  '1380',
  '1381',
  '1382',
  '1383',
  '1384',
  '1385',
  '1386',
  '1387',
  '1388',
  '1389',
  '1390',
  '1391',
  '1392',
  '1393',
  '1394',
  '1395',
  '1396',
  '1397',
  '1398',
  '1399',
  '1401',
  '1403',
  '1404',
  '1405',
  '1406',
  '1407',
  '1408',
  '1409',
  '1410',
  '1411',
  '1412',
  '1414',
  '1415',
  '1416',
  '1417',
  '1418',
  '1419',
  '1420',
  '1421',
  '1422',
  '1423',
  '1424',
  '1425',
  '1426',
  '1427',
  '1428',
  '1429',
  '1430',
  '1431',
  '1432',
  '1433',
  '1436',
  '1437',
  '1438',
  '1439',
  '1440',
  '1441',
  '1442',
  '1443',
  '1444',
  '1445',
  '1448',
  '1449',
  '1450',
  '1452',
  '1453',
  '1454',
  '1455',
  '1456',
  '1457',
  '1460',
  '1462',
  '1461',
  '1464',
  '1465',
  '1501',
  '1599',
  '9407',
  // BS AS
  '1601',
  '1602',
  '1603',
  '1605',
  '1606',
  '1607',
  '1609',
  '1611',
  '1612',
  '1613',
  '1614',
  '1615',
  '1617',
  '1618',
  '1619',
  '1620',
  '1621',
  '1623',
  '1625',
  '1627',
  '1629',
  '1631',
  '1633',
  '1635',
  '1636',
  '1637',
  '1638',
  '1640',
  '1641',
  '1642',
  '1643',
  '1644',
  '1646',
  '1647',
  '1648',
  '1649',
  '1650',
  '1651',
  '1653',
  '1655',
  '1657',
  '1659',
  '1661',
  '1663',
  '1664',
  '1665',
  '1667',
  '1669',
  '1670',
  '1672',
  '1674',
  '1676',
  '1678',
  '1682',
  '1684',
  '1686',
  '1688',
  '1702',
  '1704',
  '1706',
  '1708',
  '1712',
  '1713',
  '1714',
  '1716',
  '1718',
  '1722',
  '1723',
  '1727',
  '1731',
  '1733',
  '1735',
  '1737',
  '1739',
  '1741',
  '1742',
  '1744',
  '1746',
  '1748',
  '1751',
  '1752',
  '1754',
  '1755',
  '1757',
  '1759',
  '1761',
  '1763',
  '1765',
  '1766',
  '1768',
  '1770',
  '1771',
  '1772',
  '1773',
  '1774',
  '1776',
  '1778',
  '1786',
  '1802',
  '1804',
  '1806',
  '1807',
  '1808',
  '1812',
  '1814',
  '1815',
  '1816',
  '1822',
  '1824',
  '1825',
  '1826',
  '1828',
  '1829',
  '1831',
  '1832',
  '1833',
  '1834',
  '1836',
  '1838',
  '1839',
  '1842',
  '1846',
  '1847',
  '1849',
  '1850',
  '1851',
  '1852',
  '1854',
  '1856',
  '1858',
  '1862',
  '1864',
  '1865',
  '1870',
  '1871',
  '1872',
  '1873',
  '1874',
  '1875',
  '1876',
  '1878',
  '1879',
  '1881',
  '1882',
  '1884',
  '1885',
  '1886',
  '1888',
  '1889',
  '1890',
  '1891',
  '1893',
  '1894',
  '1895',
  '1896',
  '1897',
  '1900',
  '1901',
  '1903',
  '1905',
  '1907',
  '1909',
  '1911',
  '1913',
  '1915',
  '1917',
  '1919',
  '1921',
  '1923',
  '1925',
  '1927',
  '1929',
  '1931',
  '1980',
  '1981',
  '1983',
  '1984',
  '1986',
  '1987',
  '2168',
  '2700',
  '2701',
  '2703',
  '2705',
  '2707',
  '2709',
  '2711',
  '2713',
  '2715',
  '2717',
  '2718',
  '2720',
  '2721',
  '2740',
  '2741',
  '2743',
  '2745',
  '2747',
  '2751',
  '2752',
  '2754',
  '2760',
  '2761',
  '2763',
  '2764',
  '2800',
  '2801',
  '2802',
  '2804',
  '2806',
  '2808',
  '2812',
  '2813',
  '2814',
  '2900',
  '2901',
  '2903',
  '2905',
  '2907',
  '2909',
  '2912',
  '2914',
  '2915',
  '2916',
  '2930',
  '2931',
  '2933',
  '2935',
  '2938',
  '2942',
  '2943',
  '2944',
  '2946',
  '6000',
  '6001',
  '6003',
  '6005',
  '6007',
  '6013',
  '6015',
  '6017',
  '6018',
  '6022',
  '6027',
  '6030',
  '6031',
  '6032',
  '6034',
  '6042',
  '6050',
  '6051',
  '6053',
  '6058',
  '6062',
  '6063',
  '6064',
  '6065',
  '6070',
  '6071',
  '6073',
  '6075',
  '6077',
  '6078',
  '6101',
  '6105',
  '6223',
  '6230',
  '6231',
  '6233',
  '6235',
  '6237',
  '6239',
  '6241',
  '6242',
  '6244',
  '6335',
  '6337',
  '6338',
  '6339',
  '6341',
  '6343',
  '6346',
  '6348',
  '6400',
  '6401',
  '6403',
  '6405',
  '6407',
  '6409',
  '6411',
  '6417',
  '6422',
  '6424',
  '6430',
  '6431',
  '6433',
  '6435',
  '6437',
  '6438',
  '6439',
  '6441',
  '6443',
  '6450',
  '6451',
  '6453',
  '6455',
  '6457',
  '6459',
  '6461',
  '6463',
  '6465',
  '6467',
  '6469',
  '6471',
  '6472',
  '6474',
  '6475',
  '6476',
  '6500',
  '6501',
  '6503',
  '6505',
  '6507',
  '6509',
  '6511',
  '6513',
  '6515',
  '6516',
  '6530',
  '6531',
  '6533',
  '6535',
  '6537',
  '6538',
  '6550',
  '6551',
  '6553',
  '6555',
  '6557',
  '6559',
  '6561',
  '6600',
  '6601',
  '6603',
  '6605',
  '6607',
  '6608',
  '6612',
  '6614',
  '6616',
  '6620',
  '6621',
  '6623',
  '6625',
  '6627',
  '6628',
  '6632',
  '6634',
  '6640',
  '6641',
  '6643',
  '6645',
  '6646',
  '6648',
  '6652',
  '6660',
  '6661',
  '6663',
  '6665',
  '6667',
  '6700',
  '6701',
  '6703',
  '6705',
  '6706',
  '6708',
  '6712',
  '6720',
  '6721',
  '6723',
  '6725',
  '6727',
  '6734',
  '6740',
  '6743',
  '6746',
  '6748',
  '7000',
  '7001',
  '7003',
  '7005',
  '7007',
  '7009',
  '7011',
  '7013',
  '7020',
  '7021',
  '7100',
  '7101',
  '7103',
  '7105',
  '7106',
  '7107',
  '7108',
  '7109',
  '7111',
  '7112',
  '7113',
  '7114',
  '7116',
  '7118',
  '7119',
  '7130',
  '7135',
  '7136',
  '7150',
  '7151',
  '7153',
  '7160',
  '7161',
  '7163',
  '7165',
  '7167',
  '7169',
  '7172',
  '7174',
  '7200',
  '7201',
  '7203',
  '7205',
  '7207',
  '7208',
  '7212',
  '7214',
  '7220',
  '7221',
  '7223',
  '7225',
  '7226',
  '7228',
  '7240',
  '7241',
  '7243',
  '7245',
  '7247',
  '7249',
  '7260',
  '7261',
  '7263',
  '7265',
  '7267',
  '7300',
  '7301',
  '7303',
  '7305',
  '7307',
  '7311',
  '7313',
  '7316',
  '7318',
  '7400',
  '7401',
  '7403',
  '7404',
  '7406',
  '7407',
  '7408',
  '7412',
  '7414',
  '7500',
  '7501',
  '7503',
  '7505',
  '7507',
  '7509',
  '7511',
  '7513',
  '7515',
  '7517',
  '7519',
  '7521',
  '7530',
  '7531',
  '7533',
  '7535',
  '7536',
  '7540',
  '7541',
  '7543',
  '7545',
  '7547',
  '7548',
  '7600',
  '7601',
  '7603',
  '7605',
  '7607',
  '7609',
  '7612',
  '7613',
  '7620',
  '7621',
  '7623',
  '7630',
  '7631',
  '7633',
  '7635',
  '7637',
  '7639',
  '7641',
  '8000',
  '8101',
  '8103',
  '8105',
  '8107',
  '8109',
  '8111',
  '8113',
  '8115',
  '8117',
  '8118',
  '8122',
  '8124',
  '8126',
  '8127',
  '8129',
  '8132',
  '8134',
  '8136',
  '8142',
  '8144',
  '8146',
  '8148',
  '8150',
  '8151',
  '8153',
  '8154',
  '8156',
  '8158',
  '8160',
  '8162',
  '8164',
  '8166',
  '8168',
  '8170',
  '8171',
  '8172',
  '8174',
  '8175',
  '8180',
  '8181',
  '8183',
  '8185',
  '8187',
  '8504',
  '8506',
  '8508',
  '8512',
  // MENDOZA
  '5500',
  '5501',
  '5503',
  '5505',
  '5507',
  '5509',
  '5511',
  '5513',
  '5515',
  '5517',
  '5519',
  '5521',
  '5523',
  '5525',
  '5527',
  '5529',
  '5531',
  '5533',
  '5535',
  '5537',
  '5539',
  '5541',
  '5543',
  '5544',
  '5545',
  '5547',
  '5549',
  '5551',
  '5553',
  '5555',
  '5557',
  '5560',
  '5561',
  '5563',
  '5565',
  '5567',
  '5569',
  '5570',
  '5571',
  '5572',
  '5573',
  '5575',
  '5577',
  '5579',
  '5582',
  '5584',
  '5585',
  '5587',
  '5589',
  '5590',
  '5591',
  '5592',
  '5594',
  '5595',
  '5596',
  '5598',
  '5600',
  '5601',
  '5603',
  '5605',
  '5607',
  '5609',
  '5611',
  '5612',
  '5613',
  '5615',
  '5620',
  '5621',
  '5622',
  '5623',
  '5624',
  '5632',
  '5634',
  '5636',
  '5637',
  // CATAMARCA
  '4139',
  '4231',
  '4234',
  '4235',
  '4700',
  '4701',
  '4705',
  '4707',
  '4709',
  '4711',
  '4713',
  '4715',
  '4716',
  '4718',
  '4719',
  '4722',
  '4723',
  '4724',
  '4726',
  '4728',
  '4740',
  '4741',
  '4743',
  '4750',
  '4751',
  '4753',
  '5260',
  '5261',
  '5263',
  '5264',
  '5265',
  '5266',
  '5315',
  '5317',
  '5319',
  '5321',
  '5331',
  '5333',
  '5340',
  '5341',
  '5343',
  '5345',
  // CHACO
  '3500',
  '3501',
  '3503',
  '3505',
  '3507',
  '3509',
  '3511',
  '3513',
  '3514',
  '3515',
  '3516',
  '3518',
  '3521',
  '3522',
  '3524',
  '3526',
  '3530',
  '3531',
  '3532',
  '3534',
  '3536',
  '3540',
  '3541',
  '3543',
  '3545',
  '3700',
  '3701',
  '3703',
  '3705',
  '3706',
  '3708',
  '3712',
  '3714',
  '3716',
  '3718',
  '3722',
  '3730',
  '3731',
  '3732',
  '3733',
  '3734',
  // CHUBUT
  '8211',
  '8431',
  '9000',
  '9001',
  '9003',
  '9005',
  '9007',
  '9009',
  '9020',
  '9021',
  '9023',
  '9030',
  '9031',
  '9033',
  '9035',
  '9037',
  '9039',
  '9100',
  '9101',
  '9103',
  '9105',
  '9107',
  '9111',
  '9113',
  '9120',
  '9121',
  '9123',
  '9200',
  '9201',
  '9203',
  '9207',
  '9210',
  '9211',
  '9213',
  '9217',
  '9220',
  '9221',
  '9223',
  '9225',
  '9227',
  '9408',
  // CORBOBA
  '2189',
  '2400',
  '2401',
  '2411',
  '2413',
  '2415',
  '2417',
  '2419',
  '2421',
  '2423',
  '2424',
  '2426',
  '2428',
  '2432',
  '2433',
  '2434',
  '2435',
  '2436',
  '2525',
  '2550',
  '2551',
  '2553',
  '2555',
  '2557',
  '2559',
  '2561',
  '2563',
  '2564',
  '2566',
  '2568',
  '2572',
  '2580',
  '2581',
  '2583',
  '2585',
  '2587',
  '2589',
  '2592',
  '2594',
  '2619',
  '2624',
  '2625',
  '2627',
  '2645',
  '2650',
  '2651',
  '2655',
  '2657',
  '2659',
  '2661',
  '2662',
  '2664',
  '2670',
  '2671',
  '2675',
  '2677',
  '2679',
  '2681',
  '2684',
  '2686',
  '5000',
  '5001',
  '5003',
  '5006',
  '5008',
  '5009',
  '5010',
  '5012',
  '5014',
  '5016',
  '5017',
  '5018',
  '5019',
  '5020',
  '5021',
  '5022',
  '5023',
  '5100',
  '5101',
  '5103',
  '5105',
  '5107',
  '5109',
  '5111',
  '5113',
  '5115',
  '5117',
  '5119',
  '5121',
  '5123',
  '5125',
  '5126',
  '5127',
  '5129',
  '5131',
  '5133',
  '5135',
  '5137',
  '5139',
  '5141',
  '5143',
  '5145',
  '5147',
  '5149',
  '5151',
  '5152',
  '5153',
  '5155',
  '5156',
  '5158',
  '5162',
  '5164',
  '5165',
  '5166',
  '5168',
  '5172',
  '5174',
  '5175',
  '5176',
  '5178',
  '5182',
  '5184',
  '5186',
  '5187',
  '5189',
  '5191',
  '5192',
  '5194',
  '5196',
  '5197',
  '5199',
  '5200',
  '5201',
  '5203',
  '5205',
  '5209',
  '5211',
  '5212',
  '5214',
  '5216',
  '5218',
  '5220',
  '5221',
  '5223',
  '5225',
  '5227',
  '5229',
  '5231',
  '5233',
  '5235',
  '5236',
  '5238',
  '5239',
  '5242',
  '5243',
  '5244',
  '5246',
  '5248',
  '5249',
  '5270',
  '5271',
  '5280',
  '5281',
  '5282',
  '5284',
  '5285',
  '5287',
  '5289',
  '5291',
  '5293',
  '5295',
  '5297',
  '5299',
  '5464',
  '5800',
  '5801',
  '5803',
  '5805',
  '5807',
  '5809',
  '5811',
  '5813',
  '5815',
  '5817',
  '5819',
  '5821',
  '5823',
  '5825',
  '5827',
  '5829',
  '5831',
  '5833',
  '5837',
  '5839',
  '5841',
  '5843',
  '5845',
  '5847',
  '5848',
  '5850',
  '5851',
  '5853',
  '5854',
  '5856',
  '5857',
  '5859',
  '5862',
  '5864',
  '5865',
  '5870',
  '5871',
  '5873',
  '5875',
  '5877',
  '5879',
  '5885',
  '5887',
  '5889',
  '5891',
  '5893',
  '5900',
  '5901',
  '5903',
  '5905',
  '5907',
  '5909',
  '5911',
  '5913',
  '5915',
  '5917',
  '5919',
  '5921',
  '5923',
  '5925',
  '5927',
  '5929',
  '5931',
  '5933',
  '5935',
  '5936',
  '5940',
  '5941',
  '5943',
  '5945',
  '5947',
  '5949',
  '5951',
  '5960',
  '5961',
  '5963',
  '5965',
  '5967',
  '5969',
  '5972',
  '5974',
  '5980',
  '5984',
  '5986',
  '5987',
  '5988',
  '5989',
  '6101',
  '6120',
  '6121',
  '6123',
  '6125',
  '6127',
  '6128',
  '6132',
  '6134',
  '6140',
  '6141',
  '6142',
  '6144',
  '6225',
  '6227',
  '6270',
  '6271',
  '6272',
  '6273',
  '6275',
  // CORRIENTES
  '3194',
  '3196',
  '3197',
  '3220',
  '3222',
  '3224',
  '3226',
  '3230',
  '3231',
  '3232',
  '3234',
  '3302',
  '3306',
  '3340',
  '3342',
  '3344',
  '3346',
  '3351',
  '3358',
  '3400',
  '3401',
  '3403',
  '3405',
  '3407',
  '3409',
  '3412',
  '3414',
  '3416',
  '3418',
  '3420',
  '3421',
  '3423',
  '3425',
  '3427',
  '3428',
  '3432',
  '3433',
  '3440',
  '3441',
  '3443',
  '3445',
  '3446',
  '3448',
  '3449',
  '3450',
  '3451',
  '3453',
  '3454',
  '3460',
  '3461',
  '3463',
  '3465',
  '3466',
  '3470',
  '3471',
  '3472',
  '3474',
  '3476',
  '3480',
  '3481',
  '3483',
  '3485',
  '3486',
  '3641',
  // ENTRE RIOS
  '2805',
  '2820',
  '2821',
  '2823',
  '2824',
  '2826',
  '2828',
  '2840',
  '2841',
  '2843',
  '2845',
  '2846',
  '2848',
  '2852',
  '2854',
  '3100',
  '3101',
  '3103',
  '3105',
  '3107',
  '3109',
  '3111',
  '3112',
  '3113',
  '3114',
  '3116',
  '3117',
  '3118',
  '3122',
  '3123',
  '3125',
  '3127',
  '3128',
  '3129',
  '3132',
  '3133',
  '3134',
  '3136',
  '3137',
  '3138',
  '3142',
  '3144',
  '3150',
  '3151',
  '3153',
  '3155',
  '3156',
  '3158',
  '3162',
  '3164',
  '3170',
  '3172',
  '3174',
  '3176',
  '3177',
  '3180',
  '3181',
  '3183',
  '3185',
  '3187',
  '3188',
  '3190',
  '3191',
  '3192',
  '3199',
  '3200',
  '3201',
  '3203',
  '3204',
  '3206',
  '3208',
  '3212',
  '3214',
  '3216',
  '3218',
  '3228',
  '3229',
  '3240',
  '3241',
  '3244',
  '3246',
  '3248',
  '3252',
  '3254',
  '3260',
  '3261',
  '3262',
  '3263',
  '3265',
  '3267',
  '3269',
  '3272',
  '3280',
  '3281',
  '3283',
  '3285',
  '3287',
  // FORMOSA
  '3526',
  '3600',
  '3601',
  '3603',
  '3604',
  '3605',
  '3606',
  '3608',
  '3610',
  '3611',
  '3613',
  '3615',
  '3620',
  '3621',
  '3622',
  '3624',
  '3626',
  '3628',
  '3630',
  '3632',
  '3634',
  '3636',
  // JUJUY
  '4413',
  '4431',
  '4500',
  '4501',
  '4503',
  '4504',
  '4506',
  '4512',
  '4513',
  '4514',
  '4516',
  '4518',
  '4522',
  '4542',
  '4600',
  '4601',
  '4603',
  '4605',
  '4606',
  '4608',
  '4610',
  '4612',
  '4616',
  '4618',
  '4622',
  '4624',
  '4626',
  '4630',
  '4631',
  '4632',
  '4634',
  '4640',
  '4641',
  '4643',
  '4644',
  '4650',
  '4653',
  '4655',
  '6424',
  // LA PAMPA
  '6200',
  '6201',
  '6203',
  '6205',
  '6207',
  '6212',
  '6213',
  '6214',
  '6220',
  '6221',
  '6228',
  '6300',
  '6301',
  '6303',
  '6305',
  '6307',
  '6309',
  '6310',
  '6311',
  '6313',
  '6315',
  '6317',
  '6319',
  '6321',
  '6323',
  '6325',
  '6326',
  '6330',
  '6331',
  '6333',
  '6345',
  '6352',
  '6354',
  '6360',
  '6361',
  '6365',
  '6367',
  '6369',
  '6380',
  '6381',
  '6383',
  '6385',
  '6387',
  '8138',
  '8200',
  '8201',
  '8203',
  '8204',
  '8206',
  '8208',
  '8212',
  '8214',
  '8307',
  '8336',
  // LA RIOJA
  '5272',
  '5274',
  '5275',
  '5276',
  '5300',
  '5301',
  '5303',
  '5304',
  '5310',
  '5311',
  '5313',
  '5325',
  '5327',
  '5329',
  '5350',
  '5351',
  '5353',
  '5355',
  '5357',
  '5359',
  '5360',
  '5361',
  '5363',
  '5365',
  '5367',
  '5369',
  '5372',
  '5374',
  '5380',
  '5381',
  '5383',
  '5384',
  '5385',
  '5386',
  '5470',
  '5471',
  '5473',
  '5474',
  '5475',
  // MISIONES
  '3300',
  '3304',
  '3306',
  '3308',
  '3309',
  '3311',
  '3313',
  '3315',
  '3316',
  '3317',
  '3318',
  '3322',
  '3324',
  '3326',
  '3327',
  '3328',
  '3332',
  '3334',
  '3350',
  '3351',
  '3353',
  '3355',
  '3356',
  '3357',
  '3360',
  '3361',
  '3362',
  '3363',
  '3364',
  '3366',
  '3370',
  '3371',
  '3372',
  '3374',
  '3376',
  '3378',
  '3380',
  '3381',
  '3382',
  '3384',
  '3386',
  // NEUQUEN
  '8300',
  '8305',
  '8309',
  '8311',
  '8313',
  '8315',
  '8316',
  '8318',
  '8319',
  '8322',
  '8340',
  '8341',
  '8345',
  '8347',
  '8349',
  '8351',
  '8353',
  '8370',
  '8371',
  '8373',
  '8375',
  '8407',
  // RIO NEGRO
  '8138',
  '8301',
  '8303',
  '8305',
  '8307',
  '8308',
  '8324',
  '8325',
  '8326',
  '8328',
  '8332',
  '8333',
  '8334',
  '8336',
  '8360',
  '8361',
  '8363',
  '8364',
  '8366',
  '8400',
  '8401',
  '8402',
  '8403',
  '8409',
  '8411',
  '8412',
  '8415',
  '8416',
  '8417',
  '8418',
  '8422',
  '8424',
  '8430',
  '8500',
  '8501',
  '8503',
  '8505',
  '8514',
  '8520',
  '8521',
  '8532',
  '8534',
  '8536',
  // SALTA
  '4126',
  '4190',
  '4191',
  '4193',
  '4198',
  '4400',
  '4401',
  '4403',
  '4405',
  '4407',
  '4409',
  '4411',
  '4413',
  '4415',
  '4417',
  '4419',
  '4421',
  '4423',
  '4425',
  '4427',
  '4430',
  '4432',
  '4434',
  '4440',
  '4441',
  '4444',
  '4446',
  '4448',
  '4449',
  '4452',
  '4530',
  '4531',
  '4533',
  '4534',
  '4535',
  '4537',
  '4538',
  '4542',
  '4550',
  '4552',
  '4554',
  '4560',
  '4561',
  '4562',
  '4563',
  '4564',
  '4566',
  '4568',
  '4633',
  '4644',
  '4651',
  // SAN JUAN
  '5400',
  '5401',
  '5403',
  '5405',
  '5407',
  '5409',
  '5411',
  '5413',
  '5415',
  '5417',
  '5419',
  '5421',
  '5423',
  '5424',
  '5425',
  '5427',
  '5429',
  '5431',
  '5433',
  '5435',
  '5436',
  '5438',
  '5439',
  '5442',
  '5443',
  '5444',
  '5446',
  '5447',
  '5449',
  '5460',
  '5461',
  '5463',
  '5465',
  '5467',
  // SAN LUIS
  '5700',
  '5701',
  '5703',
  '5705',
  '5707',
  '5709',
  '5710',
  '5711',
  '5713',
  '5715',
  '5717',
  '5719',
  '5721',
  '5722',
  '5724',
  '5730',
  '5731',
  '5733',
  '5735',
  '5736',
  '5738',
  '5741',
  '5743',
  '5750',
  '5751',
  '5753',
  '5755',
  '5759',
  '5763',
  '5770',
  '5771',
  '5773',
  '5775',
  '5777',
  '5831',
  '5835',
  '5871',
  '5881',
  '5883',
  '6216',
  '6269',
  '6277',
  '6279',
  '6389',
  // SANTA CRUZ
  '9011',
  '9013',
  '9015',
  '9017',
  '9019',
  '9040',
  '9041',
  '9050',
  '9051',
  '9053',
  '9300',
  '9301',
  '9303',
  '9305',
  '9310',
  '9311',
  '9313',
  '9315',
  '9400',
  '9401',
  '9405',
  '9407',
  // SANTA FE
  '2000',
  '2101',
  '2103',
  '2105',
  '2107',
  '2108',
  '2109',
  '2111',
  '2113',
  '2115',
  '2117',
  '2119',
  '2121',
  '2123',
  '2124',
  '2126',
  '2128',
  '2132',
  '2134',
  '2136',
  '2138',
  '2142',
  '2144',
  '2146',
  '2147',
  '2148',
  '2152',
  '2154',
  '2156',
  '2170',
  '2171',
  '2173',
  '2175',
  '2177',
  '2179',
  '2181',
  '2183',
  '2185',
  '2187',
  '2200',
  '2201',
  '2202',
  '2204',
  '2206',
  '2208',
  '2212',
  '2214',
  '2216',
  '2218',
  '2222',
  '2240',
  '2241',
  '2242',
  '2246',
  '2248',
  '2252',
  '2253',
  '2255',
  '2257',
  '2258',
  '2300',
  '2301',
  '2303',
  '2305',
  '2307',
  '2309',
  '2311',
  '2313',
  '2315',
  '2317',
  '2318',
  '2322',
  '2324',
  '2326',
  '2340',
  '2341',
  '2342',
  '2344',
  '2345',
  '2347',
  '2349',
  '2352',
  '2359',
  '2401',
  '2403',
  '2405',
  '2407',
  '2409',
  '2438',
  '2440',
  '2441',
  '2443',
  '2445',
  '2447',
  '2449',
  '2451',
  '2453',
  '2454',
  '2456',
  '2500',
  '2501',
  '2503',
  '2505',
  '2506',
  '2508',
  '2512',
  '2520',
  '2521',
  '2523',
  '2527',
  '2529',
  '2531',
  '2533',
  '2535',
  '2600',
  '2601',
  '2603',
  '2605',
  '2607',
  '2609',
  '2611',
  '2613',
  '2615',
  '2617',
  '2618',
  '2622',
  '2630',
  '2631',
  '2633',
  '2635',
  '2637',
  '2639',
  '2643',
  '2701',
  '2722',
  '2723',
  '2725',
  '2726',
  '2728',
  '2729',
  '2732',
  '2918',
  '2919',
  '2921',
  '3000',
  '3001',
  '3003',
  '3005',
  '3007',
  '3009',
  '3011',
  '3013',
  '3014',
  '3016',
  '3017',
  '3018',
  '3020',
  '3021',
  '3022',
  '3023',
  '3025',
  '3027',
  '3029',
  '3032',
  '3036',
  '3038',
  '3040',
  '3041',
  '3042',
  '3044',
  '3045',
  '3048',
  '3050',
  '3051',
  '3052',
  '3054',
  '3056',
  '3057',
  '3060',
  '3061',
  '3066',
  '3070',
  '3071',
  '3072',
  '3074',
  '3076',
  '3080',
  '3081',
  '3083',
  '3085',
  '3087',
  '3516',
  '3541',
  '3550',
  '3551',
  '3553',
  '3555',
  '3557',
  '3560',
  '3561',
  '3563',
  '3565',
  '3567',
  '3569',
  '3572',
  '3574',
  '3575',
  '3580',
  '3581',
  '3583',
  '3585',
  '3586',
  '3587',
  '3589',
  '3592',
  '6009',
  '6036',
  '6039',
  '6100',
  '6103',
  '6106',
  // SANTIAGO
  '2354',
  '2356',
  '2357',
  '3046',
  '3062',
  '3064',
  '3712',
  '3714',
  '3731',
  '3736',
  '3740',
  '3741',
  '3743',
  '3745',
  '3747',
  '3749',
  '3752',
  '3760',
  '3761',
  '3763',
  '3765',
  '3766',
  '4187',
  '4189',
  '4197',
  '4200',
  '4201',
  '4202',
  '4203',
  '4205',
  '4206',
  '4208',
  '4212',
  '4220',
  '4221',
  '4223',
  '4225',
  '4230',
  '4233',
  '4234',
  '4237',
  '4238',
  '4300',
  '4301',
  '4302',
  '4304',
  '4306',
  '4308',
  '4312',
  '4313',
  '4315',
  '4317',
  '4319',
  '4321',
  '4322',
  '4324',
  '4326',
  '4328',
  '4332',
  '4334',
  '4336',
  '4338',
  '4339',
  '4350',
  '4351',
  '4353',
  '4354',
  '4356',
  '4452',
  '4613',
  '5250',
  '5251',
  '5253',
  '5255',
  '5257',
  '5258',
  '5714',
  // TIERRA DEL FUEGO
  '9409',
  '9410',
  '9411',
  '9412',
  '9420'
];
